import clsx from 'clsx'
import { FieldError, Label } from 'components/core-v2'
import { RegisterOptions, useFormContext } from 'react-hook-form'
import { ClassName } from 'types/props'

import { getFieldIds } from './__utils__/getFieldIds'
import classes from './select-field.module.scss'

interface Option {
  label: string
  value: string
}
export interface FieldProps extends ClassName {
  id: string
  isDisabled?: boolean
  label: string
  options: Option[]
  placeholderOption?: Option
  showError?: boolean
  validators?: RegisterOptions
  variant?: 'row' | 'column'
}

export const SelectField = ({
  className = '',
  id,
  isDisabled = false,
  label,
  options,
  placeholderOption,
  showError = true,
  validators,
  variant = 'row'
}: FieldProps) => {
  const {
    formState: { errors },
    register
  } = useFormContext()

  const error = errors[id]?.message
  const hasError = Boolean(error)
  const { errorId } = getFieldIds(id)

  return (
    <div
      className={clsx(classes.root, className, {
        [classes.row]: variant === 'row',
        [classes.column]: variant === 'column'
      })}
    >
      <Label className="mr-2" htmlFor={id}>
        {label}
      </Label>
      <select
        className={clsx({
          [classes.hasError]: hasError
        })}
        disabled={isDisabled}
        id={id}
        name={id}
        {...register(id, validators)}
      >
        {placeholderOption && (
          <option key={placeholderOption.value} value={placeholderOption.value}>
            {placeholderOption.label}
          </option>
        )}
        {options.map(option => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {error && showError && <FieldError id={errorId}>{String(error)}</FieldError>}
    </div>
  )
}
